import React, { useState, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import './index.scss'

export const ArticleProgressBar = ({ articleRef }) => {
  const [progress, setProgress] = useState(0)
  const rafRef = useRef(null)
  const ticking = useRef(false)

  useEffect(() => {
    const updateProgress = () => {
      if (!articleRef?.current) return

      const article = articleRef.current
      const articleTop = article.offsetTop
      const articleHeight = article.scrollHeight
      const windowHeight = window.innerHeight
      const scrollTop = window.scrollY

      // Calculate how far into the article content we've scrolled
      const articleScrollStart = articleTop
      const articleScrollEnd = articleTop + articleHeight - windowHeight

      if (scrollTop < articleScrollStart) {
        setProgress(0)
      } else if (scrollTop >= articleScrollEnd) {
        setProgress(100)
      } else {
        const scrollDistance = scrollTop - articleScrollStart
        const totalScrollDistance = articleScrollEnd - articleScrollStart
        const percentage = (scrollDistance / totalScrollDistance) * 100
        setProgress(Math.min(100, Math.max(0, percentage)))
      }

      ticking.current = false
    }

    const handleScroll = () => {
      if (!ticking.current) {
        rafRef.current = window.requestAnimationFrame(updateProgress)
        ticking.current = true
      }
    }

    updateProgress() // Calculate initial progress
    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => {
      window.removeEventListener('scroll', handleScroll)
      if (rafRef.current) {
        window.cancelAnimationFrame(rafRef.current)
      }
    }
  }, [articleRef])

  return (
    <div className='article-progress-bar'>
      <div
        className='article-progress-bar__fill'
        style={{ width: `${progress}%` }}
      />
    </div>
  )
}

ArticleProgressBar.propTypes = {
  articleRef: PropTypes.object
}

export default ArticleProgressBar
